<template lang="pug">
  sui-segment(vertical)
    sui-grid-row
      sui-grid-column
        sui-table(
          size="large",
          :columns="games.length + 1",
          unstackable,
          single-line)
          sui-table-header
            sui-table-row
              sui-table-header-cell
              sui-table-header-cell(
                text-align="center",
                v-for="game in games",
                :key="game.gameId") {{ unslugify(game.map) }}

          sui-table-body
            sui-table-row(
              v-for="team, i in teams",
              :key="team ? team.id : i")
              sui-table-cell
                sui-image(
                  centered,
                  size="tiny",
                  :src="team ? team.logo.main.svg : defaults.logo")

              sui-table-cell(
                text-align="center",
                v-for="game in games",
                :key="game.gameId")
                sui-header(size="large") {{ game.points ? game.points[i] || 0 : 0 }}
</template>

<script>
import stringsUtil from '@/utils/strings';

export default {
  name: 'GamesScoreTable',
  props: {
    games: {
      required: true,
    },
    teams: {
      required: true,
    },
  },
  data() {
    return {
      defaults: {
        name: '--',
        logo: '/logo-placeholder.svg',
      },
    };
  },
  methods: {
    unslugify: stringsUtil.unslugify,
  },
};
</script>
